import styled from 'styled-components'

export const AgentActions = styled.div`
  margin-bottom: -15px;

  button {
    margin-bottom: 15px;
  }
`
